import { buildCategoryNavigationPath } from "@faire/retailer-shared/categories/navigationPath";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import qs from "query-string";
export var getQueryParamsForSurface = function(display_page, location, match) {
    var queryParams = {};
    if (display_page === DisplayPageType.CATEGORY_PAGE) {
        var _qs_parse_filters;
        queryParams.refF = (_qs_parse_filters = qs.parse(location.search).filters) === null || _qs_parse_filters === void 0 ? void 0 : _qs_parse_filters.toString();
        var _match_params = match.params, c1CategoryUrlId = _match_params.c1CategoryUrlId, c2CategoryUrlId = _match_params.c2CategoryUrlId, c3CategoryUrlId = _match_params.c3CategoryUrlId, c4CategoryUrlId = _match_params.c4CategoryUrlId, c5CategoryUrlId = _match_params.c5CategoryUrlId, c6CategoryUrlId = _match_params.c6CategoryUrlId, c1SuppliersUrlId = _match_params.c1SuppliersUrlId;
        var categoryUrlIds = [
            c1CategoryUrlId !== null && c1CategoryUrlId !== void 0 ? c1CategoryUrlId : c1SuppliersUrlId,
            c2CategoryUrlId,
            c3CategoryUrlId,
            c4CategoryUrlId,
            c5CategoryUrlId,
            c6CategoryUrlId
        ].filter(isNotUndefined);
        if (categoryUrlIds.length > 0) {
            queryParams.refC = buildCategoryNavigationPath(categoryUrlIds);
        }
        queryParams.sortingHint = "true";
    }
    return queryParams;
};
